import { uploadFileToS3 } from 'features/entry-form-v2/data/submit-files/submitFiles';
import { FileForUpload } from 'features/entry-form-v2/data/useStoreBase64FileMutation';
import { confirmFileUploadForSurvey } from './confirmFileUploadForSurvey';
import { getFileUploadUrlForSurvey } from './getFileUploadUrlForSurvey';

export const submitFilesForSurvey = async ({
	surveyId,
	pinCode,
	entryId,
	files
}: {
	surveyId: string;
	pinCode: string;
	entryId: string;
	files: FileForUpload[];
}) => {
	const filePromises = files.map(async file => {
		const fileUploadUrl = await getFileUploadUrlForSurvey({
			surveyId,
			pinCode,
			entryId,
			fileName: file.fileName,
			fileVariableName: file.variableName
		});

		await uploadFileToS3({
			file: file.file,
			uploadUrl: fileUploadUrl.url,
			fields: fileUploadUrl.fields
		});

		await confirmFileUploadForSurvey({
			surveyId,
			pinCode,
			fileId: fileUploadUrl.fileId
		});
	});

	return await Promise.all(filePromises);
};
